/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === Math.floor(n) && (n >= 0 && n <= 1))
    return 1;
return 5;
}

export default ["nso",[["a","p"],["AM","PM"]],[["AM","PM"]],[["L","M","B","R","N","H","M"],["Lam","Mos","Bed","Rar","Ne","Hla","Mok"],["Lamorena","Mošupologo","Labobedi","Laboraro","Labone","Labohlano","Mokibelo"],["Lam","Mos","Bed","Rar","Ne","Hla","Mok"]],u,[["P","D","H","M","M","P","M","P","L","D","D","M"],["Phere","Dibo","Hlak","Mora","Mei","June","Mose","Agosetose","Lewe","Dipha","Diba","Manth"],["Janeware","Febereware","Matšhe","Aporele","Mei","June","Julae","Agosetose","Setemere","Oktobore","Nofemere","Disemere"]],u,[["BC","AD"],u,["Before Christ","Anno Domini"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,"{1} 'ka' {0}",u],["."," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"ZAR","R",u,{"JPY":["JP¥","¥"],"USD":["US$","$"],"ZAR":["R"]},"ltr", plural];
